import { Component, computed, input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { RCP_DIALOG_ITEMS } from '@app/constants/RCP_DIALOG_ITEMS';
import { IDynamicActions } from '@app/types/dynamic-actions';
import { DynamicActionsComponent } from '../dynamic-actions/dynamic-actions.component';
import { DataTestIdPipe } from '@app/pipes/data-test-id/data-test-id-pipe';

@Component({
    selector: 'app-form-dialog-wrapper',
    imports: [
        RCP_DIALOG_ITEMS,
        MatButtonModule,
        MatProgressSpinnerModule,
        DynamicActionsComponent,
        DataTestIdPipe,
    ],
    templateUrl: './form-dialog-wrapper.component.html',
    styleUrls: ['./form-dialog-wrapper.component.scss'],
})
export class FormDialogWrapperComponent {
    actions = input<IDynamicActions[]>([]);
    title = input<string>('');
    testId = input<string>('');

    testIdName = computed(() => {
        return `${this.testId()}-form-dialog`;
    });
}
